import { Banner, Text } from '@dixa/lib-shared-habla';

type Props = {
  /** Title of the archived form */
  formTitle?: string;
};

export function ArchivedFormWarning({ formTitle }: Props): JSX.Element {
  return (
    <Banner
      variant="warning"
      description={
        <Text.Paragraph>
          The form in use <strong>{formTitle || ''}</strong> has been deleted
          and its content cannot be edited. We recommend that you choose another
          form.
        </Text.Paragraph>
      }
    />
  );
}
